import React from 'react';

import { Grid } from '@mairistem/composants';

import AssistantContext from '@/contexts/AssistantContext';
import InformationsPACS from './InformationsPACS';
import Commentaire from './Commentaire';
import InformationsComplementaires from './InformationsComplementaires';
import OfficierEtatCivil from './OfficierEtatCivil';
import LieuSaisie from './LieuSaisie';
import InformationsDissolution from './InformationsDissolution';
import Steps from '@/enums/Steps';

const StepPACS = () => {
  const {
    numero,
    statut,
    registre,
    onChange,
    conventionDeclaration: {
      dateIrrecevabilite,
      dateEnregistrement,
      identifiantIrrecevabilite,
      signataireNomFamille,
      signatairePrenom,
      signataireQualite,
      commentaire,
      conforme,
      annule,
      adressePacs,
      dateMariage,
      dateSignification,
      dateDeclarationUnitDi,
      dateDeclarationJointDi,
      dateDissolution,
      identifiantTypeDissolution,
      partenaire1DateDeces,
      partenaire2DateDeces,
      typeComparution,
    },
    isDissolutionMode,
    selectedDeclarationType,
    errors,
  } = React.useContext(AssistantContext);

  const isModificative = selectedDeclarationType === 'modificative';
  const errorsStep = errors?.[Steps.PACS] || {};

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: isModificative ? '100%' : 'auto',
      }}
    >
      <Grid style={isModificative ? { flex: '0 0 auto' } : undefined}>
        {!isModificative && (
          <Grid.Row>
            <Grid.Column>
              {!isDissolutionMode ? (
                <InformationsPACS
                  registre={registre}
                  numero={numero}
                  statut={statut}
                  dateIrrecevabilite={dateIrrecevabilite}
                  dateEnregistrement={dateEnregistrement}
                  typeComparution={typeComparution}
                  identifiantIrrecevabilite={identifiantIrrecevabilite}
                  errors={errorsStep}
                  onChange={onChange}
                />
              ) : (
                <InformationsDissolution
                  dateDissolution={dateDissolution}
                  identifiantTypeDissolution={identifiantTypeDissolution}
                  dateSignification={dateSignification}
                  dateMariage={dateMariage}
                  dateDecesPartenaire1={partenaire1DateDeces}
                  dateDecesPartenaire2={partenaire2DateDeces}
                  dateDecisionUnilaterale={dateDeclarationUnitDi}
                  dateDeclarationConjointe={dateDeclarationJointDi}
                  errors={errorsStep}
                  onChange={onChange}
                />
              )}
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column width={10}>
            <OfficierEtatCivil
              signataireNomFamille={signataireNomFamille}
              signatairePrenom={signatairePrenom}
              signataireQualite={signataireQualite}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column width={6}>
            <LieuSaisie
              adressePacs={adressePacs}
              errors={errorsStep}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid style={isModificative ? { flex: 1, minHeight: 0 } : undefined}>
        <Grid.Row>
          <Grid.Column width={10}>
            <Commentaire commentaire={commentaire} onChange={onChange} />
          </Grid.Column>
          <Grid.Column width={6}>
            <InformationsComplementaires
              conforme={conforme}
              annule={annule}
              selectedDeclarationType={selectedDeclarationType}
              onChange={onChange}
              isDissolutionMode={isDissolutionMode}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default StepPACS;
